<template>
  <div class="courseSignList">
    <div class="orgreleasecourse">
      <IndexHeader />
      <div class="releasecourseBoxSgl">
        <el-form class="el-form el-form--label-left">
          <div class="header clear">
            <div class="title">签到单管理</div>
          </div>
          <div class="line"></div>
          <div class="list-list">
            <div class="result">
              <div
                class="list-content"
                v-for="(item,index) of listData.data"
                :key="item.value"
              >
                <div class="list-top">
                  <span class="order-number order-date">课程小结名称：{{ item.scheduleName }}</span>
                </div>
                <div class="list-bottom-excel">
                  <span class="name">签到表格</span>
                  <span class="content" v-if="item.scheduleSigninExcels.length>0">
                    <el-button v-for="(excelItem,excelIndex) of item.scheduleSigninExcels" :key="excelIndex"
                    @click="handleExcel(item.scheduleId,index)" 
                    type="text"
                    :disabled = !showCreditsStatus
                    >{{excelItem.name}}
                    </el-button>
                  </span>
                  <span class="content" v-if="item.scheduleSigninExcels.length==0">
                    <el-button 
                    @click="handleExcel(item.scheduleId,index)" 
                    type="text"
                    :disabled = !showCreditsStatus
                    >{{'上传Excel文件'}}
                    </el-button>
                  </span>
  
                  <!-- <span :model="item.orderSn" class="content" @click="handleExcel(item.orderSn)">
                        {{item.orderSn}}
                  </span> -->
                </div>
                <div class="list-bottom-picture">
                  <span class="name">签到图片</span>
                  <span class="content">
                    <!-- <xxComponent v-model="varA" />  等价于<xxComponent :modelValue="varA" @update:modealValue="varA = $event" />
                            所以@update:modelValue="uploadAvatarSuccess($event)"可以不写  因为query.cover已经被赋值
                    -->
                    <QiniuImageUpload class="contentImgs" v-model="item.scheduleSigninImgs" :limit="9" :isShowUploadBtn = showCreditsStatus  />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <div class="bottomBtnBox flex">
          <div class="submitBtn" @click="confirmSignList()">确定保存</div>
        </div> 
      </div>
    </div>

    <!--导入Excel-->
    <el-dialog
      :title="upload.title"
      v-model="upload.open"
      width="400px"
      append-to-body
    >
      <el-upload
        ref="uploadRef"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :on-error="handleUploadError"
        :auto-upload="false"
        drag
      >
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <template #tip>
          <div class="el-upload__tip text-center">
            <span>仅允许导入xls、xlsx格式文件。</span>
            <el-link
              type="primary"
              :underline="false"
              style="font-size: 12px; vertical-align: baseline"
              @click="downLoadExcelTemplate"
              >下载模板</el-link
            >
          </div>
        </template>
      </el-upload>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="submitFileForm" :disabled="uploadingExcel">确 定</el-button>
          <el-button @click="upload.open = false">取 消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import IndexHeader from "../../components/IndexHeader/TopBar";
import { ref, reactive, getCurrentInstance, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { fa } from "element-plus/es/locale";
import { courseSignManagerList,courseSignManagerConfirm, courseSignManagerSubmit} from "../../server/jigou/order";
import QiniuImageUpload from "../../components/ImageUpload/qiniuImageUpload.vue"
import { downLoadFile } from "../../server/base";
import { requestToken } from '../../common/js/request_token.js'

const route = useRoute();
const query = reactive({
  courseId: route.query.id
});
const scheduleQuery = reactive({
  scheduleId: ''
});
const listData = reactive({
  data: [],
});
//点击得某个excel
const currentExcelIndex = ref(0)
const currentExcelScheduleName = ref('')
/*** 批量导入订单 */
const upload = reactive({
  // 是否显示弹出层（批量导入）
  open: false,
  // 弹出层标题（批量导入订单）
  title: "",
  // 是否禁用上传
  isUploading: false,
  // 是否更新已经存在的用户数据
  updateSupport: 0,
  // 设置上传的请求头部let token = requestToken();
  headers: { Authorization: "Bearer " + "" + requestToken() },
  // 上传的地址
  url: process.env.VUE_APP_API_BASE_URL + "system/credits/importofficedata?scheduleId=" + '',
});
const { proxy } = getCurrentInstance()
//签到单列表状态审核通过则不可编辑
const showCreditsStatus = ref(true)
//正在上传Excel时 确定按钮无法点击 解决点击上传多个问题
const uploadingExcel = ref(false);
/** 导入按钮操作 */
function handleExcel(id,index) {
  upload.title = "导入签到表格";
  upload.open = true;
  scheduleQuery.scheduleId = id;
  currentExcelIndex.value = index;
  currentExcelScheduleName.value = listData.data[index].scheduleName
  upload.url = process.env.VUE_APP_API_BASE_URL + "system/credits/import-offline-data?scheduleId=" + listData.data[index].scheduleId;
}
/**文件上传中处理 */
const handleFileUploadProgress = (event, file, fileList) => {
  upload.isUploading = true;
};
/** 文件上传成功处理 */
const handleFileSuccess = (response, file, fileList) => {
  upload.open = false;
  uploadingExcel.value = false;
  upload.isUploading = false;
  proxy.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.msg + "</div>", "导入结果", { dangerouslyUseHTMLString: true });
  proxy.$refs["uploadRef"].handleRemove(file);
  if (response.code == 200) {
    //先暂时置空  只上传一个excel
    listData.data[currentExcelIndex.value].scheduleSigninExcels = [];
    listData.data[currentExcelIndex.value].scheduleSigninExcels.push({ id: 0, url: response.data.url,name:currentExcelScheduleName.value });
  }
};
// 上传失败
function handleUploadError() {
  proxy.$modal.msgError("上传Excel失败");
  upload.open = false;
  upload.isUploading = false;
  uploadingExcel.value = false;
}
/** 提交上传文件 */
function submitFileForm() {
  uploadingExcel.value = true;
  proxy.$refs["uploadRef"].submit();
};
/** 导出按钮操作 */
function downLoadExcelTemplate() {
  downLoadFile("/system/credits/down-offline-template",scheduleQuery,currentExcelScheduleName.value)
}
//签到管理确定按钮事件
async function confirmSignList(){
  for (const item of listData.data) {
    if (item.scheduleSigninExcels.length === 0) {
      proxy.$modal.msgError("请提交上传签到表格");
      return;
    }
    if (item.scheduleSigninImgs.length === 0) {
      proxy.$modal.msgError("请提交上传签到图片");
      return;
    }
  }
  let res = await courseSignManagerConfirm(listData.data);
  if (res != false) {
    window.history.go(-1);
    proxy.$modal.msgSuccess("保存成功");
  }
}
//签到管理提交审核
async function submitSignList(){
  for (const item of listData.data) {
    if (item.scheduleSigninExcels.length === 0) {
      proxy.$modal.msgError("请提交上传签到表格");
      return;
    }
    if (item.scheduleSigninImgs.length === 0) {
      proxy.$modal.msgError("请提交上传签到图片");
      return;
    }
  }
  proxy.$modal.loading("正在保存数据，请稍候...");
  let res = await courseSignManagerSubmit(listData.data);
  if (res != false) {
    proxy.$modal.closeLoading();
    window.history.go(-1);
    proxy.$modal.msgSuccess("提交审核成功");
  }
}

//获取签到管理相关数据
async function getSignManagerList() {
  proxy.$modal.loading("正在加载数据，请稍候...");
  let res = await courseSignManagerList(query.courseId);
  console.log('bbbbbbbb',res)
  if (res != false) {
    listData.data = res.list;
    if (res.courseinfo.creditsStatus == '审核通过') {
      showCreditsStatus.value = false;
    } else {
      showCreditsStatus.value = true;
    }
    setTimeout(() =>{
      proxy.$modal.closeLoading();
    },1000)
  }
}
getSignManagerList();
</script>
<style>
.timeSame {
  padding-top: 20px;
}
.bottomBtnBox{
  margin: 48px 0 0 80px;
  justify-content: space-around;
}
.bottomBtnBox .submitBtn{
    cursor: pointer;
    float: left;
    text-align: center;
    width: 217px;
    height: 38px;
    background: #003399;
    border-radius: 3px;
    line-height: 38px;
    font-size: 14px;
    font-weight: 400;
    color: #fff
}
</style>